import {
  Document,
} from '../../../../types/models';
import SynchronousDocumentOperation from './synchronous';

export default class SetSignalWordsOperation extends SynchronousDocumentOperation {
  readonly type = 'set-signal-words';

  isEnabled: boolean;

  constructor(documentId: string, isEnabled: boolean) {
    super(documentId);
    this.isEnabled = isEnabled;
  }

  apply(document: Document): Document {
    return {
      ...document,
      meta: {
        ...document.meta,
        hasSignalWords: this.isEnabled,
      },
    };
  }
}
